import About from "../components/about_page_about_section/About";
import Fun_facts from "../components/fun_facts/fun_facts";
import Skills from "../components/skills_about_page/skills";

const About_page = () => {
  // in this video i will continue to create About page
  return <>
    <About />
    <Skills/>
    <Fun_facts/>
  </>;
};
export default About_page;
